import { useEffect, useState } from "react";
import { Toast, Loading } from "@xp-design/mobile";
import { getActivityInfo } from "@/api/configPage.ts";
import "./index.less";
import { useSearchParams } from "react-router-dom";
import { trackGdp } from "@/utils/gio-report";
import { getChannel } from "@/utils/tools";

// 活动详情
const ActivityDetail = () => {
  const [desc, setDesc] = useState();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    document.title = "活动详情";
    getDetail();
  }, []);

  // 获取详情
  const getDetail = async () => {
    try {
      Loading.show("加载中...");
      const res = await getActivityInfo({
        activityCode: searchParams.get("activityCode"),
      });
      if (res.code === 200) {
        trackGdp("P20191", "B001", {
          trackName: "充电_营销活动详情_页面访问",
          origin: getChannel(),
          userType: "",
          activityId: searchParams.get("activityCode"),
        });
        // setDesc(res.data?.lotteryActivityDto?.activityDescribe)
        const originalText = res.data?.lotteryActivityDto?.activityDescribe;

        const formattedText = originalText?.split("\n").map((line, index) => (
          <div
            key={index}
            style={{
              // textIndent: "2em", // 首行缩进2字符
              textAlign: "justify", // 启用两端对齐
              textJustify: "inter-character", // 优化中文对齐
              wordBreak: "break-all", // 强制长单词换行
              maxWidth: "100%", // 固定容器宽度（按需调整）
              margin: "0 auto", // 居中显示（可选）
            }}
          >
            {line}
          </div>
        ));

        setDesc(formattedText);
      } else {
        Toast.show({
          content: res.msg,
        });
      }
    } finally {
      Loading.hide();
    }
  };

  return (
    <div className="activityDetail">
      {/* <NavBar title="活动详情" /> */}
      <div className="desc">{desc}</div>
    </div>
  );
};

export default ActivityDetail;
